import PolicyPage from "./PolicyPage";

export default function TermsPage() {
  return (
    <PolicyPage
      eyebrow="Legal"
      title="Terms of Service"
      lastUpdated="February 2026"
      testid="page-terms"
    >
      <p>
        Welcome to Smibha Luxe Candles. By accessing smibhaluxe.com or placing an order with us, you agree
        to be bound by the following Terms of Service (&ldquo;Terms&rdquo;). These Terms govern
        your use of our website, products, and services. Please read them carefully.
      </p>

      <h2 className="text-2xl font-black tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        1. About us
      </h2>
      <p>
        Smibha Luxe Candles is a small-batch luxury candle studio operated from 21 Whittaker
        Cres, Cambridge, Ontario N1T 1Z4, Canada. References to &ldquo;we,&rdquo;
        &ldquo;us,&rdquo; or &ldquo;our&rdquo; refer to Smibha Luxe Candles.
      </p>

      <h2 className="text-2xl font-black tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        2. Eligibility &amp; account
      </h2>
      <p>
        You must be at least 18 years old (or the age of majority in your jurisdiction) to purchase
        from Smibha Luxe Candles. By placing an order you confirm that the information you provide is
        accurate and that you are authorised to use the payment method submitted at checkout.
      </p>

      <h2 className="text-2xl font-black tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        3. Orders, pricing &amp; availability
      </h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>
          All prices are displayed in USD by default and may be adjusted by region at checkout.
          Taxes and duties (where applicable) are calculated at checkout.
        </li>
        <li>
          Products are subject to availability. We reserve the right to limit quantities, refuse,
          or cancel any order at our discretion — including suspected fraudulent activity.
        </li>
        <li>
          In the rare case of a pricing or product description error, we will contact you before
          shipping and offer the option to confirm the corrected order or cancel for a full refund.
        </li>
      </ul>

      <h2 className="text-2xl font-black tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        4. Payments
      </h2>
      <p>
        Payments are processed by Stripe. By submitting payment information you authorise us (and
        Stripe) to charge the total amount due. Stripe&rsquo;s own terms also apply to your
        payment.
      </p>

      <h2 className="text-2xl font-black tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        5. Shipping, returns &amp; refunds
      </h2>
      <p>
        Shipping, tracking, returns, refunds and cancellations are governed by our{" "}
        <a href="/shipping-returns" className="underline">Shipping, Returns and Refunds</a> policy,
        which is incorporated into these Terms by reference. We generally do not accept returns for
        change of mind or unwanted products; where a product is defective, damaged, unsafe or not as
        described, we will provide any remedy required by law.
      </p>

      <h2 className="text-2xl font-black tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        6. Product safety &amp; candle care
      </h2>
      <p>
        Smibha Luxe Candles are hand-poured for decorative and intended use only. Always follow
        the candle-care card included with each order: trim the wick to 5 mm before each light,
        never leave a burning candle unattended, keep out of reach of children and pets, burn on
        a heat-safe surface, and discontinue use when 1 cm of wax remains. Smibha Luxe Candles
        is not responsible for damage caused by misuse.
      </p>

      <h2 className="text-2xl font-black tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        7. Intellectual property
      </h2>
      <p>
        All content on smibhaluxe.com — including logos, images, copy, collection stories, packaging
        design, and source code — is the property of Smibha Luxe Candles or its licensors and is
        protected by copyright and trademark laws. You may not reproduce, distribute, or create
        derivative works without our prior written consent.
      </p>

      <h2 className="text-2xl font-black tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        8. Limitation of liability
      </h2>
      <p>
        To the maximum extent permitted by law, Smibha Luxe Candles and its officers, directors,
        employees, and agents are not liable for any indirect, incidental, special, consequential,
        or punitive damages arising from your use of the Services. Our total aggregate liability
        for any claim will not exceed the amount you paid for the product giving rise to the claim.
      </p>

      <h2 className="text-2xl font-black tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        9. Governing law &amp; jurisdiction
      </h2>
      <p>
        These Terms are governed by the laws of the Province of Ontario and the federal laws of
        Canada applicable therein. Any dispute will be resolved exclusively in the courts of the
        Province of Ontario, unless prohibited by your local consumer protection laws.
      </p>

      <h2 className="text-2xl font-black tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        10. Changes to these Terms
      </h2>
      <p>
        We may update these Terms from time to time. The most current version will always be posted
        on this page with the &ldquo;Last updated&rdquo; date refreshed. Continued use of the
        Services constitutes acceptance of any revisions.
      </p>

      <h2 className="text-2xl font-black tracking-tight mt-8" style={{ fontFamily: "Outfit" }}>
        11. Contact
      </h2>
      <p>
        Questions about these Terms? Email{" "}
        <a className="underline" href="mailto:info@smibhaluxecandles.com">info@smibhaluxecandles.com</a>.
      </p>

      <p className="text-sm text-zinc-500 mt-10">
        Smibha Luxe Candles · 21 Whittaker Cres, Cambridge, ON N1T 1Z4, Canada · This document is
        professional placeholder text and should be reviewed by an attorney before deployment to
        production.
      </p>
    </PolicyPage>
  );
}
